import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { FontColors, FontSizes, FontWeights } from '../../../../enums/fonts.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import { getFontAlignment, getFontColor, getFontDecoration, getFontSize, getFontTransform, getFontWeight } from '../../../../styles/styled-components/font.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import { truncateText } from '../../../../styles/styled-components/text.js';
import '../../../../styles/styled-components/tooltip.js';
import { BaseText } from '../base-text/base-text.js';

const BaseStandardText = (props)=>{
    const { align, children, className, color, decoration, ellipsis, italic, size, transform, weight, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseText, {
        ...otherProps,
        className: classnames({
            'bf-text__standard': true,
            [`bf-text__standard--align-${align}`]: !!align,
            [`bf-text__standard--color-${color}`]: !!color,
            [`bf-text__standard--decoration-${decoration}`]: !!decoration,
            'bf-text__standard--ellipsis': ellipsis,
            'bf-text__standard--italic': italic,
            [`bf-text__standard--size-${size}`]: !!size,
            [`bf-text__standard--transform-${transform}`]: !!transform,
            [`bf-text__standard--weight-${weight}`]: !!weight,
            [`${className}`]: !!className
        })
    }, children);
};
const Text = styled(BaseStandardText)`
  box-sizing: border-box;
  display: block;
  ${({ align })=>getFontAlignment({
        align
    })}
  ${({ color, theme })=>getFontColor({
        color,
        darkMode: theme.darkMode
    })}
  ${({ decoration })=>getFontDecoration({
        decoration
    })}
  ${({ ellipsis })=>ellipsis ? truncateText() : ''}
  ${({ size })=>getFontSize({
        size
    })}
  ${({ transform })=>getFontTransform({
        transform
    })}
  ${({ italic, weight })=>getFontWeight({
        italic,
        weight
    })}
`;
/**
 * A paragraph of text. Text can contain [phrasing content](https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#phrasing_content) like `<img>` and `<a>` tags. All text needs to be translated by your app.
 *
 * IMPORTANT: You will need to have Brandfolder's `@font-face` for Circular.
 * Consider using `<BrandfolderGlobalStyles>` component with `styled-components`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/p
 *
 * @param props StandardTextProps
 * @returns FunctionComponent<StandardTextProps>
 */ const StandardText = (props)=>{
    const { color = FontColors.Default, size = FontSizes.Small, weight = FontWeights.Book, ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Text, {
        ...otherProps,
        color: color,
        size: size,
        weight: weight
    }));
};

export { BaseStandardText, StandardText };
//# sourceMappingURL=standard-text.js.map
